<mat-progress-bar mode="indeterminate" *ngIf="isShowLoader" color="accent"></mat-progress-bar>
<div class="container">
    <div fxLayout="row wrap" class="header m-b-10">
        <div fxFlex="93" fxLayoutAlign="center center">
            <span class="header-text">{{selectedQuestion.title}}</span>
        </div>
        <div class="pointer" (click)="onClosePopup()">
            <mat-icon>clear</mat-icon>
        </div>
    </div>
    <div *ngIf="selectedQuestion.key === 'surveys'">
        <div *ngFor="let survey of surveys" class="m-b-20">
            <mat-checkbox [checked]="survey.selected" (change)="selectSurvey(survey)">{{survey.title}}</mat-checkbox>
            <div fxLayout="row wrap" class="m-l-20" *ngFor="let response of survey.responses; let i=index;">
                <mat-checkbox [checked]="response.selected" (change)="selectResponse(survey, response)">Response {{i+1}}
                </mat-checkbox>
            </div>
        </div>
    </div>
    <div class="doc" fxLayout="row" *ngIf="selectedQuestion.key === 'documents'">
        <div fxFlex="25" *ngFor="let documnet of documents; let i=index;" class="m-b-20">
            <div fxLayout="row">
                <img [src]="documnet.src" width="100" height="100">
            </div>
            <div fxLayout="row">
                <mat-checkbox [(ngModel)]="documnet.selected">document {{i+1}}</mat-checkbox>
            </div>
        </div>
    </div>
    <div>
        <button color="primary" type="submit" (click)="onSubmit()"
            mat-raised-button>{{selectedQuestion.button_text}}</button>
    </div>
</div>